import React from "react"

function AlignCenter({ size }) {
    return (
        <svg viewBox="0 0 24 24" height={size}><path d="M11 2h2v5h8v3h-8v4h5v3h-5v5h-2v-5H6v-3h5v-4H3V7h8z"></path></svg>)
}

export default AlignCenter